<script setup lang="ts">
import { NxtFormSection } from '@future-harry/nxt-styles';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import LanguagesFormSection from '@/apps/admin/components/forms/settings/LanguagesFormSection.vue';
import CompanyUrlSection from '@/apps/admin/components/forms/settings/CompanyUrlSection.vue';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });
</script>

<template>
   <div>
      <NxtFormSection :title="$t('job-board.settings.general')">
         <CompanyUrlSection v-model="jobBoard" />
      </NxtFormSection>
      <NxtFormSection :title="$t('job-board.settings.language')">
         <LanguagesFormSection v-model="jobBoard" />
      </NxtFormSection>
   </div>
</template>
